(function addSectionProductReviewsClass() {
    const tryAddClass = () => {
        const reviewsElement = document.querySelector('div[data-bv-show="reviews"]');
        if (!reviewsElement) return false;
        const section = reviewsElement.closest('.section');
        if (!section) return false;
        section.classList.add('section-product-reviews');
        return true;
    };

    if (tryAddClass()) return;

    const observer = new MutationObserver(() => {
        if (tryAddClass()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            if (tryAddClass()) observer.disconnect();
        });
    }
})();

(function enforceBvHistogramStarColor() {
    const selector = '.bv_histogram_list_container svg path, .bv_histogram_list_container svg polygon';
    const color = '#F68628';

    const applyColor = (root) => {
        if (!root || root.nodeType !== Node.ELEMENT_NODE) return;
        const stars = root.matches(selector) ? [root] : root.querySelectorAll(selector);
        stars.forEach((star) => star.style.setProperty('fill', color, 'important'));
    };

    applyColor(document.documentElement);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach(applyColor);
        });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(function styleBvSubmissionForm() {
    const STAMP = 'data-st-bv-ips-style';
    const CSS = `
        .ips__sc-r8pfgm-3 {
            font-size: 18px !important;
        }
    `;

    const inject = (root) => {
        const host = root === document ? document.head : root;
        if (!host || host.querySelector(`style[${STAMP}]`)) return;
        const style = document.createElement('style');
        style.setAttribute(STAMP, '');
        style.textContent = CSS;
        host.appendChild(style);
    };

    const visit = (root) => {
        if (root.querySelector('[class*="ips__"]')) inject(root);
        root.querySelectorAll('*').forEach((el) => {
            if (el.shadowRoot) visit(el.shadowRoot);
        });
    };

    let scanFrame = null;
    const scan = () => {
        if (scanFrame) return;
        scanFrame = requestAnimationFrame(() => {
            scanFrame = null;
            visit(document);
        });
    };

    scan();
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();

window.formatBvNumReviewsText = (function () {
    const countRegex = /\(\s*(\d+)\s*\)/;

    const formatNode = (el) => {
        if (!el || !el.classList || !el.classList.contains('bv_numReviews_text')) return;
        const match = (el.textContent || '').match(countRegex);
        if (!match) return;
        const count = parseInt(match[1], 10);
        if (Number.isNaN(count)) return;
        const formatted = `${count} ${count === 1 || count === 0 ? 'Review' : 'Reviews'}`;
        if (el.textContent === formatted) return;
        el.textContent = formatted;
    };

    const formatAll = (root) => {
        if (!root) return;
        if (root.classList && root.classList.contains('bv_numReviews_text')) {
            formatNode(root);
        }
        if (root.querySelectorAll) {
            root.querySelectorAll('.bv_numReviews_text').forEach(formatNode);
        }
    };

    formatAll(document);

    const observer = new MutationObserver(() => formatAll(document));
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
    });

    return formatAll;
})();

(function scrollToReviewsWithHeaderOffset() {
    const getHeaderOffset = () => {
        const headerVar = getComputedStyle(document.body).getPropertyValue('--header-height').trim();
        const parsed = parseInt(headerVar, 10);
        if (!Number.isNaN(parsed) && parsed > 0) return parsed;
        const header = document.querySelector('sticky-header') || document.querySelector('header');
        return header ? header.offsetHeight : 0;
    };

    const activateReviewsTab = () => {
        const reviewsTabLink = document.querySelector('.tab-link[data-tab*="review" i]');
        if (reviewsTabLink && !reviewsTabLink.classList.contains('active')) {
            reviewsTabLink.click();
        }
        document.querySelectorAll('.tab-content details, .accordion__content-group details').forEach((detail) => {
            if (!detail.hasAttribute('open')) detail.setAttribute('open', '');
        });
    };

    const getTarget = () =>
        document.querySelector('.section-product-reviews')
        || document.querySelector('div[data-bv-show="reviews"]');

    const scrollToTarget = () => {
        const target = getTarget();
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 16;
        window.scrollTo({ top, behavior: 'auto' });
    };

    let reviewsScrollFrame = null;
    let reviewsResizeObserver = null;
    let reviewsHashObserver = null;

    const scheduleScrollToTarget = () => {
        if (reviewsScrollFrame) cancelAnimationFrame(reviewsScrollFrame);
        reviewsScrollFrame = requestAnimationFrame(() => {
            reviewsScrollFrame = requestAnimationFrame(() => {
                reviewsScrollFrame = null;
                scrollToTarget();
            });
        });
    };

    const observeReviewsLayout = () => {
        const target = getTarget();
        if (!target || typeof ResizeObserver === 'undefined') return;

        if (reviewsResizeObserver) reviewsResizeObserver.disconnect();
        reviewsResizeObserver = new ResizeObserver(scheduleScrollToTarget);
        reviewsResizeObserver.observe(target);
    };

    const activateAndScrollToReviews = () => {
        activateReviewsTab();
        scheduleScrollToTarget();
        observeReviewsLayout();
    };

    const handleReviewsCountClick = (event) => {
        const trigger = event.target.closest && event.target.closest('.bv_numReviews_text');
        if (!trigger) return;
        if (!getTarget()) return;

        event.preventDefault();
        event.stopPropagation();

        activateAndScrollToReviews();
    };

    window.addEventListener('click', handleReviewsCountClick, true);
    document.addEventListener('click', handleReviewsCountClick, true);

    const bindReviewCountTriggers = () => {
        document.querySelectorAll('.bv_numReviews_text').forEach((trigger) => {
            if (trigger.dataset.bvScrollBound === 'true') return;
            trigger.dataset.bvScrollBound = 'true';
            trigger.addEventListener('click', handleReviewsCountClick, true);
        });
    };

    bindReviewCountTriggers();
    const observer = new MutationObserver(bindReviewCountTriggers);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    const handleReviewsHashNavigation = () => {
        if (window.location.hash !== '#reviews') return false;
        if (!getTarget()) return false;

        activateAndScrollToReviews();
        return true;
    };

    const disconnectReviewsHashObserver = () => {
        if (!reviewsHashObserver) return;
        reviewsHashObserver.disconnect();
        reviewsHashObserver = null;
    };

    const waitForReviewsHashTarget = () => {
        if (window.location.hash !== '#reviews') {
            disconnectReviewsHashObserver();
            return;
        }
        if (handleReviewsHashNavigation()) {
            disconnectReviewsHashObserver();
            return;
        }

        if (reviewsHashObserver) return;
        reviewsHashObserver = new MutationObserver(() => {
            if (handleReviewsHashNavigation()) disconnectReviewsHashObserver();
        });
        reviewsHashObserver.observe(document.documentElement, { childList: true, subtree: true });
    };

    waitForReviewsHashTarget();
    window.addEventListener('hashchange', waitForReviewsHashTarget);
})();

window.formatBvWriteReviewButton = (function () {
    const SELECTOR = '.bv_button_buttonMinimalist.bv_war_button';
    const isMatch = (el) => el && el.classList
        && el.classList.contains('bv_button_buttonMinimalist')
        && el.classList.contains('bv_war_button');

    const formatNode = (el) => {
        if (!isMatch(el)) return;
        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
            if (!node.nodeValue || node.nodeValue.indexOf('Write a review') === -1) continue;
            const next = node.nodeValue.replace(/Write a review/g, 'Write a Review');
            if (next !== node.nodeValue) node.nodeValue = next;
        }
    };

    const formatAll = (root) => {
        if (!root) return;
        if (isMatch(root)) formatNode(root);
        if (root.querySelectorAll) {
            root.querySelectorAll(SELECTOR).forEach(formatNode);
        }
    };

    formatAll(document);

    const observer = new MutationObserver(() => formatAll(document));
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
    });

    return formatAll;
})();

window.bvCallback = function (BV) {
    BV.configure('global', {
        events: {
            bvRender: function (data) {
                if (data.BVProduct != "swat_reviews") return;
                const targetNode = document.querySelector('div[data-bv-show="reviews"]').shadowRoot;
                // Options for the observer (which mutations to observe)
                const config = { attributes: true, childList: true, subtree: true, characterData: true };

                const getFilterContainer = () => {
                    const classic = (targetNode.getElementById && targetNode.getElementById('bv_review_filter_container'))
                        || document.getElementById('bv_review_filter_container');
                    if (classic) return classic;
                    const filterRow = (targetNode.querySelector && targetNode.querySelector('.bv-rnr__sdlnh3-0'))
                        || document.querySelector('.bv-rnr__sdlnh3-0');
                    if (filterRow) return filterRow;
                    const sortDropdown = (targetNode.getElementById && targetNode.getElementById('bv-dropdown-select-reviews'))
                        || document.getElementById('bv-dropdown-select-reviews');
                    if (sortDropdown) {
                        return sortDropdown.closest('.bv-rnr__sc-11r39gb-0');
                    }
                    return null;
                };

                const hideMobileFiltersToggle = () => {
                    const filterContainer = getFilterContainer();
                    if (!filterContainer) return;

                    const filtersBtn = Array.from(filterContainer.querySelectorAll('button, [role="button"]'))
                        .find((el) => (el.textContent || '').trim() === 'Filters');

                    if (filtersBtn) {
                        let wrapper = filtersBtn;
                        while (wrapper.parentElement && wrapper.parentElement !== filterContainer) {
                            wrapper = wrapper.parentElement;
                        }
                        wrapper.style.display = 'none';

                        Array.from(filterContainer.children).forEach((child) => {
                            if (child === wrapper) return;
                            const computed = child.getAttribute('style') || '';
                            if (child.hasAttribute('hidden')) child.removeAttribute('hidden');
                            if (/display\s*:\s*none/i.test(computed)) {
                                child.style.display = '';
                            }
                        });
                    }

                    filterContainer.querySelectorAll('[hidden], [aria-hidden="true"]').forEach((el) => {
                        if (el.closest('button')) return;
                        el.removeAttribute('hidden');
                        el.removeAttribute('aria-hidden');
                    });
                };

                const replaceSecondaryRatingLabels = () => {
                    const labelMap = {
                        'Quality of Product': 'Quality',
                        'Value of Product': 'Value'
                    };
                    const walker = document.createTreeWalker(targetNode, NodeFilter.SHOW_TEXT);
                    let node;
                    while ((node = walker.nextNode())) {
                        const trimmed = node.nodeValue.trim();
                        if (labelMap[trimmed]) {
                            node.nodeValue = node.nodeValue.replace(trimmed, labelMap[trimmed]);
                        }
                    }
                };

                const starIconSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path d="M3.0625 15L4.375 9.45833L0 5.72917L5.75 5.22917L8 0L10.25 5.25L16 5.72917L11.625 9.45833L12.9375 15L8 12.0625L3.0625 15Z" fill="currentColor"/></svg>';
                const replaceHistogramStarLabels = () => {
                    const starRegex = /^(\d+)\s*stars?$/i;
                    const walker = document.createTreeWalker(targetNode, NodeFilter.SHOW_TEXT);
                    const toReplace = [];
                    let node;
                    while ((node = walker.nextNode())) {
                        const match = node.nodeValue.trim().match(starRegex);
                        if (match) {
                            toReplace.push({ node, count: parseInt(match[1], 10) });
                        }
                    }
                    toReplace.forEach(({ node, count }) => {
                        const wrapper = document.createElement('span');
                        wrapper.className = 'bv-rating-stars-icons';
                        wrapper.innerHTML = `${count}${starIconSVG}`;
                        node.parentNode.replaceChild(wrapper, node);
                    });
                };

                const dropdownArrowSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none"><path d="M5 6.0625L0 1.0625L1.0625 0L5 3.9375L8.9375 0L10 1.0625L5 6.0625Z" fill="#064A45"/></svg>';
                const replaceDropdownArrowSVG = () => {
                    const arrows = targetNode.querySelectorAll('svg.bv-rnr__sc-18sau7x-0');
                    arrows.forEach((svg) => {
                        const parsed = new DOMParser().parseFromString(dropdownArrowSVG, 'image/svg+xml').documentElement;
                        svg.replaceWith(parsed);
                    });
                };

                const alignHelpfulToMiddleColumn = () => {
                    if (window.innerWidth > 1366) return;
                    const helpfuls = targetNode.querySelectorAll('.bv-rnr__v2pr51-3');
                    helpfuls.forEach((helpful) => {
                        const grid = helpful.closest('.bLRaeH')
                            || helpful.closest('.bv-rnr__sc-16dr7i1-26')?.firstElementChild;
                        if (!grid || grid.children.length < 2) return;
                        const middleColumn = grid.children[1];
                        if (!middleColumn) return;

                        const reviewRoot = grid.closest('.bv-rnr__sc-16dr7i1-1') || grid;
                        const label = reviewRoot.querySelector('.bv-rnr__v2pr51-2');

                        if (label && !middleColumn.contains(label)) {
                            middleColumn.appendChild(label);
                        }
                        if (!middleColumn.contains(helpful)) {
                            middleColumn.appendChild(helpful);
                        }
                    });
                };

                window.addEventListener('resize', alignHelpfulToMiddleColumn);

                const syncAuthorPopupState = () => {
                    const overlay = targetNode.querySelector('.bv-rnr__sc-11o48jq-0');
                    document.body.classList.toggle('bv-author-popup-open', !!overlay);
                };

                // Callback function to execute when mutations are observed
                const callback = (mutationsList) => {
                    try {
                        hideMobileFiltersToggle();
                        replaceSecondaryRatingLabels();
                        replaceHistogramStarLabels();
                        replaceDropdownArrowSVG();
                        alignHelpfulToMiddleColumn();
                        syncAuthorPopupState();
                        if (typeof window.formatBvNumReviewsText === 'function') {
                            window.formatBvNumReviewsText(targetNode);
                        }
                        if (typeof window.formatBvWriteReviewButton === 'function') {
                            window.formatBvWriteReviewButton(targetNode);
                        }
                        for (const mutation of mutationsList) {
                            if (mutation.type === 'childList') {
                                if (mutation?.target?.classList?.contains('bv-rnr__reme6t-0')) {
                                    const parent = mutation.target.parentNode.parentNode.parentNode.parentNode;
                                    let wrapper;
                                    if (parent) {
                                        wrapper = parent.querySelector('.bv-review-reviewer') || document.createElement('div');
                                        wrapper.className = 'bv-review-reviewer';
                                        parent.insertBefore(wrapper, mutation.target.parentNode.parentNode.parentNode);
                                        if (parent.querySelector('.bv-rnr__tbt1zd-0') && mutation.target.parentNode.nextSibling.querySelector('.bv-rnr__tbt1zd-0 ')) {
                                            wrapper.
                                                appendChild(parent.querySelector('.bv-rnr__tbt1zd-0')).
                                                appendChild(mutation.target.parentNode.nextSibling.querySelector('.bv-rnr__tbt1zd-0 '));
                                        }
                                    }

                                    if (mutation.target.parentNode.nextSibling) {
                                        const movedNode = mutation.target.parentNode.nextSibling.appendChild(mutation.target.parentNode);
                                        const g3jej5 = wrapper && wrapper.querySelector('.bv-rnr__g3jej5-1');
                                        if (g3jej5) {
                                            movedNode.appendChild(g3jej5);
                                        }
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        console.error(e);
                    }
                };

                // Create an observer instance linked to the callback function
                const observer = new MutationObserver(callback);

                // Start observing the target node for configured mutations
                observer.observe(targetNode, config);

                const reviewsHost = (targetNode && targetNode.host)
                    || document.querySelector('div[data-bv-show="reviews"]');
                if (reviewsHost && typeof ResizeObserver !== 'undefined' && !reviewsHost.dataset.stResizeBound) {
                    reviewsHost.dataset.stResizeBound = 'true';
                    const getScrollTrigger = () => window.ScrollTrigger
                        || (window.gsap
                            && window.gsap.core
                            && typeof window.gsap.core.globals === 'function'
                            && window.gsap.core.globals().ScrollTrigger);
                    let scrollTriggerRefreshTimer = null;
                    const refreshScrollTriggers = () => {
                        const ScrollTrigger = getScrollTrigger();
                        if (!ScrollTrigger || typeof ScrollTrigger.refresh !== 'function') return;

                        if (scrollTriggerRefreshTimer) clearTimeout(scrollTriggerRefreshTimer);
                        scrollTriggerRefreshTimer = setTimeout(() => ScrollTrigger.refresh(), 250);
                    };
                    new ResizeObserver(refreshScrollTriggers).observe(reviewsHost);
                }

                if (targetNode) {
                    const style = document.createElement('style');
                    style.textContent = `
                    .LdftG,.hYfXdP,.hlmGGE,.imWQPM,.emxjNa,.jwtsnW,.ehKkiG,.fWhVuK,.kKvCud,.jMfhAF,.itPLql,.fenJuz {
                        background-color: #064A45 !important;
                    }
                    .cVxDVg,.gkHBtN,.jimmKu {
                        border-radius: 10px !important;
                        padding: 30px;
                        margin-top: 20px;
                        border-radius: 8px;
                        background: #fff;
                    }
                    .jyAvbC,.hVbhWS,.hWTlDM,.fILajl,.eRHCCX {
                        background-color: transparent !important;
                    }
                    .qwAZF,.gkHBtN {
                        border:none !important;
                    }
                    #bv_review_maincontainer .eRHCCX {
                        font-family: var(--font-heading--family);
                        font-size: var(--font-size--2xl) !important;
                        line-height: var(--line-height--2xl) !important;
                        margin: 0;
                    }
                    #bv_review_maincontainer {
                        background: transparent;
                        position: relative;
                    }
                    .eRHCCX,.bv-rnr__tbt1zd-0,.ggtdkV {
                        color:#064A45!important;
                        font-weight: 700!important;
                        font-size: 16px!important;
                    }
                    .iyMpGJ {
                        color:#064A45;
                        font-weight: 700;
                    }
                    .bv-rnr__sc-10ra6n1-2 {
                        margin-top: -60px;
                        position: absolute;
                        right: 124px;
                    }
                    .fBaJUx li button,.fBaJUx li a, .fPudqV li a, .fPudqV li button {
                        border-radius: 50%;
                        width: 48px;
                        height: 48px;
                        background-color: #F68628;
                        border:none;
                        color:#064A45;
                    }
                    .hPUyti {
                        background-color:#F2F4F7;
                        border-radius: 8px;
                    }
                    .bv_content_label_row {
                        color: #000;
                        font-family: 'Sohne Breit';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 20px;
                        padding: 0;
                        margin-bottom: 8px;
                    }
                    .dtiaIO {
                        color:#34C759!important;
                        font-weight: 700!important;
                        font-size: 16px!important;
                    }
                    .eGuNKi svg {
                        height: 15px;
                    }

                    .eGuNKi circle {
                        fill: #34C759;
                    }
                    .bv-review-reviewer {
                        width: 100%;
                    }
                    .kpzdM,.dkdwd {
                        width: 100%;
                    }
                    .jLOzaq {
                        width: 100%;
                    }
                    .eCooNZ {
                        text-align: center;
                        display: inline-block;
                        width: 100%;
                    }
                    .jFkYkw,.cQtEeG,.inyGNP {
                        display:none!important;
                    }
                    .bLRaeH {
                        display: grid;
                        grid-template-columns: 2.5fr 2fr 1fr;
                    }
                    .bv-rnr__g3jej5-1 {
                        font-size: small;
                        flex: auto;
                    }
                    .hPUyti .ccIBfQ {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                    }
                    .ebAYHr,.gFORuJ {
                        height: 4px;
                    }
                    .gfkpcr {
                        min-width: 25px;
                        font-size: 16px;
                    }
                    .bv-rnr__sc-16dr7i1-26 > div {
                        display: grid;
                        grid-template-columns: 1fr 2fr 1fr;
                    }
                    .gsHTvK {
                        margin: 0;
                        padding: 0;
                    }

                    .bv-rnr__sc-16dr7i1-0 {
                        margin: 0 0 40px;
                    }

                    .bv-rnr__sc-16j1lpy-1 {
                        margin-top: 0;
                        color: #064A45;
                        font-family: "Sohne Breit";
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 32px;
                    }

                    .bv-rnr__sc-10ra6n1-2 {
                        margin-top: 0;
                        top: 0;
                        right: 0;
                        width: auto;
                        z-index: 1;
                    }

                    .bv-rnr__reme6t-0 {
                       white-space: nowrap;
                       line-height: 16px;
                    }

                    .bv_stars_component_container,
                    .bv-rnr__reme6t-0,
                    .bv-reviews-product-rating-star,
                    .primary-rating-star-container,
                    .bv-rnr__jcyw8r-0 {
                        color: #FFD100 !important;
                    }

                    :is(
                        .bv_stars_component_container,
                        .bv-rnr__reme6t-0,
                        .bv-reviews-product-rating-star,
                        .primary-rating-star-container,
                        .bv-rnr__jcyw8r-0
                    ) :is(
                        path[fill="#F58025" i],
                        polygon[fill="#F58025" i],
                        path[fill="#F68628" i],
                        polygon[fill="#F68628" i],
                        path[style*="fill: #F58025" i],
                        polygon[style*="fill: #F58025" i],
                        path[style*="fill:#F58025" i],
                        polygon[style*="fill:#F58025" i],
                        path[style*="fill: #F68628" i],
                        polygon[style*="fill: #F68628" i],
                        path[style*="fill:#F68628" i],
                        polygon[style*="fill:#F68628" i],
                        path[style*="rgb(245, 128, 37)" i],
                        polygon[style*="rgb(245, 128, 37)" i],
                        path[style*="rgb(246, 134, 40)" i],
                        polygon[style*="rgb(246, 134, 40)" i]
                    ) {
                        fill: #FFD100 !important;
                        stroke: #FFD100 !important;
                    }

                    .bv-rnr__zv3ryj-1 svg {
                        width: 14px;
                        height: 14px;
                        position: absolute;
                        height: 14px;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }

                    .bv-rnr__zv3ryj-1 a,
                    .bv-rnr__zv3ryj-1 button {
                        width: 48px !important;
                        height: 48px !important;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-color: var(--color-yellow) !important;
                        color: var(--color-blue);
                        border-radius: 48px !important;
                        cursor: pointer;
                        position: static;
                        margin: 0;
                        border: none !important;
                        padding: 0 !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        position: relative;
                    }

                    .bv-rnr__sc-16j1lpy-5 {
                        margin: 0;
                        background: #e8faf9;
                        height: auto;
                    }

                    .bv-rnr__sc-1r4hv38-3 .bv-rnr__sc-16j1lpy-5 {
                        background: none;
                    }

                    .bv-rnr__sc-1vjvgwp-0 {
                        display: none;
                    }

                     .bv-rnr__sc-16j1lpy-5 img {
                        mix-blend-mode: multiply;
                        height: 40px;
                     }

                    .bv-rnr__sc-16dr7i1-5 {
                        display: none;
                    }

                    .bv-rnr__sc-16j1lpy-2 {
                        padding: 0;
                    }

                    .bv-rnr__sc-10ra6n1-0 {
                        padding: 40px;
                        background: white;
                        border-radius: 8px;
                        border-bottom: none;
                        margin-bottom: 16px;
                        display: flex;
                        gap: 40px;
                    }

                    .bv-rnr__rpifwc-1 {
                        margin: 0;
                        padding: 0;
                    }

                    .bv-rnr__sc-2kyvjj-0 .bv-rnr__sc-2kyvjj-3 {
                        margin: 16px auto 0;
                        display: flex;
                        gap: 8px;
                        justify-content: center;
                        align-items: center;
                    }

                    .bv-rnr__sc-2kyvjj-0 {
                        text-align: center;
                    }

                    .bv-rnr__rpifwc-2 .primary-rating-star-container,
                    .bv-rnr__rpifwc-2 .primary-rating-count {
                        color: #000;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                        min-width: unset;
                    }

                    .bv-rnr__sc-2kyvjj-5 {
                        display: none;
                    }

                    .bv-rnr__rpifwc-2 .primary-rating-star-container .bv-rnr__bm6gry-0 {
                        display: none;
                    }

                    .bv-rating-stars-icons {
                        display: inline-flex;
                        gap: 8px;
                        align-items: end;
                        line-height: 1;
                    }

                    .bv-rating-stars-icons svg {
                        width: 16px;
                        height: 15px;
                        flex-shrink: 0;
                        color: #F68628;
                    }

                    .bv-rnr__sc-1od8hxa-0 .bv-rating-stars-icons svg {
                        color: #F68628;
                    }

                    .bv-rnr__ppunu1-0 {
                        height: 4px;
                        border-radius: 0;
                        background: #e5e5e5;
                        box-shadow: none;
                    }

                    .bv-rnr__ppunu1-1 {
                        background: #064A45;
                    }

                    .bv-rnr__rpifwc-3 {
                        padding: 0 8px;
                    }

                    .bv-rnr__sc-157rd1w-1 {
                        color: #064A45;
                        font-family: 'Sohne Breit';
                        font-size: 48px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 1;
                        padding: 0;
                    }

                    .bv-rnr__sdlnh3-0 select {
                        border-radius: 4px;
                        border: 1px solid #D6D5E6;
                        color: #505050;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                        margin: 0;
                        padding-right: 40px;
                        appearance: none;
                          -webkit-appearance: none;
                          -moz-appearance: none;
                          padding-right: 40px;
                          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M10 13.0625L5 8.0625L6.0625 7L10 10.9375L13.9375 7L15 8.0625L10 13.0625Z' fill='%23064A45'/%3E%3C/svg%3E");
                          background-repeat: no-repeat;
                          background-position: right 12px center;
                          background-size: 20px 20px;
                    }

                    .bv-rnr__sc-157rd1w-0 {
                        margin-top: 0;
                    }

                    .bv-rnr__sc-157rd1w-3 {
                        padding: 0;
                        text-decoration: none;
                    }

                    .bv-rnr__sc-157rd1w-2 {
                        padding: 0;
                        height: auto;
                        text-align: center;
                        color: #505050;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 1.5;
                    }

                    .bv-rnr__sc-16j1lpy-2  {
                        color: var(--Brand-Primary-Betta-Blue, #064A45);
                        text-align: center;
                        font-family: 'Sohne Breit';
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 1.2;
                    }

                    .bv-rnr__sc-2kyvjj-4 {
                        width: 46px;
                        height: 46px;
                        min-width: 46px;
                        min-height: 46px;
                        border-radius: 4px;
                        border: 1px solid #D6D5E6 !important;
                        background: #FFF;
                    }

                    .bv-reviews-product-rating-star {
                        padding: 0;
                    }

                    .bv-rnr__jcyw8r-0 {
                        width: 16px;
                        height: 16px;
                        margin: 0 2px;
                    }

                    .bv-rnr__jcyw8r-0 path {
                        stroke: #F68628;
                        stroke-width: 1px;
                    }

                    .bv-rnr__di1qf-1 {
                        margin: 0;
                        padding: 40px;
                        display: flex;
                        flex-wrap: unset;
                        gap: 40px;
                    }

                    .bv-rnr__di1qf-0 {
                        border-radius: 8px;
                        background: transparent;
                        border: none;
                    }

                    .bv-rnr__di1qf-5 {
                        padding: 0;
                        order: 2;
                    }

                    .bv-rnr__di1qf-4 {
                        margin: 0;
                        display: grid;
                    }

                    .bv-rnr__ppunu1-7 {
                        width: 68px;
                        height: 4px;
                        border-radius: 0;
                        box-shadow: none;
                    }

                    .bv-rnr__ppunu1-6,
                    .bv-rnr__ppunu1-8 {
                        height: 4px;
                    }

                    .bv-rnr__di1qf-6 {
                        order: 1;
                        color: #000;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 1.5;
                        margin-bottom: 8px;
                        padding: 0;
                    }

                    .bv-rnr__sc-16j1lpy-2.egpeLU,
                    #bv_review_filter_container .bv-rnr__sc-16j1lpy-2 {
                        display: none;
                    }

                    .bv-rnr__sc-11r39gb-1:last-child .bv-rnr__sc-11r39gb-0 {
                        padding: 0;
                        margin: 40px 0 0;
                        background: transparent;
                        display: flex;
                        flex-direction: row;
                    }

                    #bv_review_filter_container,
                    .bv-review-filter-bar {
                        display: flex;
                        gap: 24px;
                        align-items: center;
                        flex-wrap: wrap;
                    }

                    .bv-rnr__sc-5jc2zu-0 {
                        position: relative;
                        flex: 1;
                        min-width: 260px;
                    }

                    .bv-rnr__sc-5jc2zu-0 svg {
                        position: absolute;
                        left: 16px;
                        top: 50%;
                        transform: translateY(-50%);
                        pointer-events: none;
                        width: 20px;
                        height: 20px;
                    }

                    .bv-rnr__sc-5jc2zu-2 {
                        width: 100%;
                        height: 46px;
                        padding: 0 16px 0 40px;
                        border: 1px solid #D6D5E6;
                        border-radius: 4px;
                        background-color: #FFF;
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'%3E%3Cpath d='M12.9375 14L7.95833 9.02083C7.54167 9.32639 7.08479 9.56597 6.58771 9.73958C6.09063 9.91319 5.5616 10 5.00063 10C3.61132 10 2.43056 9.51389 1.45833 8.54167C0.486111 7.56944 0 6.38889 0 5C0 3.61111 0.486111 2.43056 1.45833 1.45833C2.43056 0.486111 3.61111 0 5 0C6.38889 0 7.56944 0.486111 8.54167 1.45833C9.51389 2.43056 10 3.61132 10 5.00063C10 5.5616 9.91319 6.09063 9.73958 6.58771C9.56597 7.08479 9.32639 7.54167 9.02083 7.95833L14 12.9375L12.9375 14ZM5 8.5C5.97222 8.5 6.79861 8.15972 7.47917 7.47917C8.15972 6.79861 8.5 5.97222 8.5 5C8.5 4.02778 8.15972 3.20139 7.47917 2.52083C6.79861 1.84028 5.97222 1.5 5 1.5C4.02778 1.5 3.20139 1.84028 2.52083 2.52083C1.84028 3.20139 1.5 4.02778 1.5 5C1.5 5.97222 1.84028 6.79861 2.52083 7.47917C3.20139 8.15972 4.02778 8.5 5 8.5Z' fill='%23064A45'/%3E%3C/svg%3E");
                        background-repeat: no-repeat;
                        background-position: 16px center;
                        background-size: 16px 16px;
                        color: #000;
                        font-family: 'Lato';
                        font-size: 16px;
                        line-height: 48px;
                        box-sizing: border-box;
                        height: 48px;
                    }

                    .bv-rnr__sc-5jc2zu-2::placeholder {
                        color: #505050;
                    }

                    .bv-rnr__sc-5jc2zu-2:focus {
                        outline: none;
                        border-color: #064A45;
                    }

                    .bv-rnr__sc-5jc2zu-1 {
                        width: 100%;
                        position: relative;
                    }

                    .bv-rnr__sc-5jc2zu-4,
                    .bv-rnr__sc-5jc2zu-3 {
                        display: none;
                    }

                    .bv-rnr__sdlnh3-0 {
                        display: flex !important;
                        gap: 24px !important;
                    }

                    .bv-rnr__sc-1od8hxa-0 .bv-rnr__sdlnh3-0 {
                        gap: 8px;
                        flex-wrap: wrap;
                    }

                    .bv-rnr__sc-1od8hxa-0 {
                        padding: 0;
                    }

                    .bv-rnr__sc-16j1lpy-3,
                    .bv-rnr__sc-16j1lpy-4 {
                        margin: 0;
                    }

                    .bv-rnr__sc-16j1lpy-3 {
                        color: #fff !important;;
                    }

                    .bv-rnr__sc-16j1lpy-3:hover {
                        color: #fff !important;;
                    }

                    .bv-rnr__sc-16j1lpy-3 svg path {
                        fill: #fff;
                    }

                    .bv-rnr__sc-16j1lpy-3:hover svg path {
                        fill: #fff;
                    }

                    .bv-rnr__sdlnh3-0 > * {
                        display: block !important;
                    }

                    #bv_review_filter_container button[aria-label="Filters"],
                    #bv_review_filter_container button[aria-label^="Filters"],
                    #bv_review_filter_container button[aria-expanded][aria-controls*="filter"] {
                        display: none !important;
                    }

                    .bv-rnr__rzy3jf-0 {
                        margin: 0;
                        padding: 0;
                    }

                    .bv-rnr__sc-1wzl89g-0 {
                        margin: 0;
                        padding: 12px 16px;
                        height: 22px;
                        min-width: 149.5px;
                        border-radius: 4px;
                        border: 1px solid #D6D5E6;
                        background: #FFF;
                        color: #505050;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 1.5;
                    }

                    .bv-rnr__sc-1wzl89g-1 {
                        left: 0;
                        top: 0;
                    }

                    .bv-rnr__sc-11r39gb-0 {
                        margin: 0 0 40px;
                    }

                    .bv-rnr__wnep33-0 {
                        margin: 0;
                    }

                    .bv-rnr__sc-11r39gb-2 {
                        color: #000;
                        font-family: Lato;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 1.5;
                    }

                    .bv-rnr__sc-13ijx62-3 {
                        padding: 0 16px;
                        height: 46px;
                        width: auto;
                        border-radius: 4px;
                        border: 1px solid #D6D5E6;
                        background: #FFF;
                    }

                    .bv-rnr__sc-13ijx62-8,
                    .bv-rnr__sc-13ijx62-4 {
                        color: #505050;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                    }

                    .bv-rnr__sc-13ijx62-4 {
                        padding-left: 0;
                        padding-right: 4px;
                    }

                    .bv-rnr__sc-13ijx62-4:after {
                        content: ':';
                    }

                    .bv-rnr__sc-13ijx62-0 {
                        border: none;
                        background: none;
                        border-radius: unset;
                    }

                    .bv-rnr__sc-13ijx62-3 div:not([class*='bv']) svg {
                        margin-left: 16px;
                        display: block;
                    }

                    .bv-rnr__sc-11r39gb-1 {
                        border-bottom: none;
                        background: inherit;
                    }

                    .bv-rnr__sc-16dr7i1-1 {
                        margin: 0;
                        border-radius: 8px;
                        background: #fff;
                        padding: 24px;
                    }

                    .bv-rnr__sc-16dr7i1-1 .bv-rnr__sc-16dr7i1-0 {
                        margin-bottom: 0;
                    }

                    .bv-rnr__sc-16dr7i1-27 {
                        gap: 40px;
                    }

                    .bv-rnr__sc-16dr7i1-20 {
                        display: none;
                    }

                    .bv-rnr__tbt1zd-0 {
                        margin-top: 0;
                        width: auto;
                    }

                    .bv-rnr__sc-16dr7i1-6 {
                        padding: 0;
                        margin: 0;
                        color: #064A45 !important;
                        font-family: 'Lato' !important;
                        font-size: 16px !important;
                        font-style: normal !important;
                        font-weight: 700 !important;
                        line-height: 1.5 !important;
                        text-decoration: none !important;
                    }

                    .bv-rnr__sc-16dr7i1-17 {
                        color: #064A45;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 1.5;
                        margin: 0;
                        width: auto;
                    }

                    .bv-rnr__sc-16dr7i1-21 {
                        display: flex;
                        gap: 24px;
                        align-items: start;
                        margin-bottom: 24px;
                        justify-content: start;
                        position: relative;
                        padding-right: 110px;
                        width: calc(100% - 110px);
                    }

                    .bv-rnr__sc-16dr7i1-22 {
                        padding: 0;
                    }

                    .bv-rnr__sc-16dr7i1-19 {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        justify-content: space-between;
                        gap: 24px;
                        margin-top: 3px;
                    }

                    .bv-rnr__g3jej5-1 {
                        flex: unset;
                        color: var(--Brand-Secondary-Black, #000);
                        text-align: right;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 1.5;
                        position: absolute;
                        right: 0;
                        top: 0;
                    }

                    .bv-rnr__sc-16dr7i1-7 {
                        padding: 0;
                    }

                    .bv-rnr__sc-16dr7i1-7 .bv-rnr__sc-16dr7i1-3 {
                        color: #000;
                        font-family: 'Lato';
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 20px;
                        margin-bottom: 16px;
                    }

                    #carousel_header,
                    .bv-rnr__sc-11cxkec-0 {
                        display: none;
                    }

                    #reviews_container {
                        display: grid;
                        gap: 16px;
                    }

                    .bv-rnr__sc-16dr7i1-13 {
                        margin: 16px 0 24px;
                    }

                    .bv-rnr__sc-1y8lyw5-1 {
                        padding-right: 4px;
                    }

                    .bv-rnr__sc-1i2zvgg-1 {
                        color: #34C759;
                        font-family: 'Lato';
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 20px;
                        margin-right: 0;
                    }

                    .bv-rnr__sc-16dr7i1-15 {
                        margin: 24px 0 0;
                    }

                    .bv-rnr__v2pr51-2 {
                        color: #000;
                        font-family: 'Sohne Breit';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 20px;
                        padding: 0;
                        margin: 0 16px 0 0;
                        display: inline-block;
                    }

                    .bv-rnr__sc-314f1h-1,
                    .bv-rnr__sc-1tt2trz-1 {
                        color: #000;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 1.5;
                        margin: 0 0 0 8px;
                    }

                    .bv-rnr__v2pr51-3 {
                        display: inline-flex;
                        gap: 16px;
                        align-items: center;
                        margin: 0;
                    }

                    .bv-rnr__g8boo9-0 {
                        margin: 0;
                    }

                    .bv-rnr__g8boo9-0 button,
                    .bv-rnr__g8boo9-0 button:hover {
                        color: #000 !important;
                        font-family: 'Lato' !important;
                        font-size: 16px !important;
                        font-style: normal !important;
                        font-weight: 400 !important;
                        line-height: 1.5 !important;
                        text-decoration: underline !important;
                        padding: 0 !important;
                        outline: none !important;
                    }

                    .bv-rnr__g8boo9-0 button:hover {
                        text-decoration: none !important;
                    }

                    .bv-rnr__sc-16dr7i1-12 .bv-rnr__di1qf-0 {
                        padding: 0;
                    }

                    .bv-rnr__sc-16dr7i1-12 .bv-rnr__di1qf-1 {
                        padding: 24px;
                        border-radius: 8px;
                        background: #F2F4F7;
                        gap: 24px;
                    }

                    .bv-rnr__sc-16dr7i1-12 .bv-rnr__di1qf-1 .bv-rnr__di1qf-2 {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }

                    .bv-rnr__sc-16dr7i1-12 .bv-rnr__di1qf-1 .bv_content_label_row {
                        margin-bottom: 0;
                        min-width: 64px;
                    }

                    .bv-rnr__sc-16dr7i1-12 .bv-rnr__di1qf-4 {
                        display: flex;
                        gap: 8px;
                        align-items: center;
                    }

                    .bv-rnr__sc-16dr7i1-12 .bv-rnr__di1qf-6,
                    .bv-rnr__sc-16dr7i1-12 .bv-rnr__di1qf-5 {
                        order: unset;
                        margin-bottom: 0;
                    }

                    .bv-rnr__sc-16dr7i1-12 .bv-rnr__ppunu1-7 {
                        width: 26.4px;
                    }

                    .bv-rnr__sc-1kd7i6j-0 {
                        border-radius: 4px;
                        border: 1px solid #D6D5E6;
                        background: #fff;
                        padding: 0 16px;
                        height: 48px;
                    }

                    .bv-rnr__sc-107gs2s-2 {
                        gap: 24px;
                    }

                    .bv-rnr__sc-1kd7i6j-2 {
                        color: #505050;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                    }

                    .bv-rnr__sc-188gd9s-0 .bv-review-reviewer {
                        display: none;
                    }

                    .bv-rnr__sc-188gd9s-2,
                    .bv-rnr__sc-1tvt4yi-3,
                    .bv-rnr__sc-188gd9s-5 {
                        background-color: transparent;
                        color: #505050;
                        font-family: 'Lato';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                    }

                    .bv-rnr__sc-4rnerp-1 {
                        color: #064A45 !important;
                        font-family: "Sohne Breit" !important;
                        font-size: 24px !important;
                        font-style: normal !important;
                        font-weight: 700 !important;
                        line-height: 32px !important;
                    }

                    .bv-rnr__sc-188gd9s-4 {
                        display: flex;
                        align-items: center;
                    }

                    #bv-reviews-sort-by-positive svg {
                        margin-left: 0;
                    }

                    .bv-rnr__l6jz5k-0,
                    .bv-rnr__sc-1tvt4yi-1,
                    .bv-rnr__sc-1tvt4yi-3,
                    .bv-rnr__g8boo9-0 button,
                    .bv-rnr__g8boo9-0 a {
                        outline: none !important;
                    }

                    .bv-rnr__sc-1tvt4yi-3:hover {
                        background: #064A45;
                        color: #fff;
                    }

                    .bv-rnr__r9ibfb-0 {
                        position: relative;
                    }

                    .bv-rnr__nvkx1s-4 {
                        font-size: 11px;
                        font-family: 'Lato';
                        color: #000;
                    }

                    .bv-rnr__f7tz1h-2 .bv-rnr__sc-16dr7i1-26 > div {
                        display: block;
                    }

                    .bv-rnr__f7tz1h-2 .bv-rnr__g3jej5-1 {
                        position: unset;
                    }

                    .bv-rnr__f7tz1h-2 .bv-rnr__sc-16dr7i1-26 {
                        margin: 0;
                    }

                    .bv-rnr__f7tz1h-2 .bv-rnr__sc-16dr7i1-19 {
                        margin: 16px 0;
                    }

                    .bv-rnr__f7tz1h-2 .bv-rnr__sc-16dr7i1-21 {
                        width: 100%;
                        padding-right: 0;
                    }

                    @media screen and (max-width: 1023px) {
                        .cVxDVg, .gkHBtN, .jimmKu {
                            padding: 10px;
                        }
                        .bv-rnr__sc-10ra6n1-2 {
                            position: static;
                            margin: 8px 0 24px;
                        }
                        .cwArUT {
                            padding-top: 0;
                            margin: 0;
                        }
                        .cwArUT.fILajl {
                            margin: 0;
                            padding-bottom: 8px
                        }
                        .bv-rnr__sc-16j1lpy-5 {
                            margin: 0;
                            height: auto;
                        }

                        .bv-rnr__sc-16dr7i1-0 {
                            margin: 0 0 8px;
                        }

                        .bv-rnr__sc-10ra6n1-0 {
                            padding: 24px 16px;
                            gap: 24px;
                            display: grid;
                        }

                        .bv_rating_content2 {
                            order: 1;
                        }

                        .bv_rating_content1 {
                            order: 2;
                        }

                        .bv_rating_content3 {
                            order: 3;
                        }

                        .bv-rnr__di1qf-1 {
                            padding: 24px 16px;
                            gap: 24px;
                        }

                        .bv-rnr__ppunu1-7 {
                            width: 58px;
                        }

                        .#bv_review_filter_container {
                            margin: 24px 0;
                        }

                        .bv-rnr__sc-5jc2zu-0 {
                            width: 100%;
                        }

                        .bv-rnr__sc-11r39gb-2 {
                            text-align: left;
                            padding: 0;
                        }

                        .bv-rnr__sc-11r39gb-0 {
                            margin: 0 0 30px;
                            display: flex;
                            gap: 16px;
                            flex-direction: column;
                        }

                        #bv_review_filter_container {
                            margin: 24px 0;
                        }

                        .bv-rnr__sc-16dr7i1-1 {
                            padding: 24px 16px 16px;
                        }

                        .bv-rnr__sc-16dr7i1-26 > div {
                            display: block;
                        }

                        .bv-review-reviewer {
                            margin-bottom: 24px;
                        }

                        .bv-rnr__sc-16dr7i1-21 {
                            display: block;
                            position: relative;
                            padding-top: 16px;
                        }

                        .bv-rnr__sc-16dr7i1-17 {
                            margin: 8px 0;
                        }

                        .bv-rnr__sc-16dr7i1-19 {
                            display: block;
                        }

                        .bv-rnr__sc-16dr7i1-21 .bv-rnr__reme6t-0 {
                            position: absolute;
                            top: 0;
                            left: 0;
                        }

                        .bv-rnr__sc-16dr7i1-12 {
                            margin-top: 24px;
                        }

                        .bv-rnr__sc-16dr7i1-12 .bv-rnr__ppunu1-7 {
                            width: 28px;
                        }

                        .bv-rnr__sc-16dr7i1-14 {
                            margin-bottom: 24px;
                        }

                        .bv-rnr__sc-2kyvjj-0 .bv-rnr__sc-2kyvjj-3 {
                            max-width: 100%;
                        }

                        .bv-rnr__sdlnh3-0 {
                            display: flex !important;
                            gap: 24px !important;
                            flex-wrap: unset;
                            width: 100%;
                        }

                        .bv-rnr__sc-1od8hxa-0 .bv-rnr__sdlnh3-0 {
                            gap: 8px !important;
                            flex-wrap: wrap;
                        }
                    }
                    `;
                    targetNode.appendChild(style);
                }
            }
        }
    });
};
